module.exports = __webpack_public_path__ + "static/img/cart-tx.0dd719f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cart-tx.png
// module id = WFqo
// module chunks = 1